export const Event = {
    MutePlayer: 'MUTE_PLAYER',
    PlaybackFinished: 'PLAYBACK_FINISHED',
    EnablePlayer: 'ENABLE_PLAYER',
}
